import { ssrApi } from 'api/ssr';
import { CasinoPage, Props } from 'components/template/casino';
import { api } from 'lib/api';
import { ParsedUrlQuery } from 'querystring';
import {
  isValidEntity,
  notFoundResult,
  unwrapEntity,
} from 'utils/ssr-not-found';

export default function Casino({ casino, rtpReviews, complaints }: Props) {
  return (
    <CasinoPage
      casino={casino}
      rtpReviews={rtpReviews}
      complaints={complaints}
    />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { id } = query;

  const casino = await ssrApi.casinos.getById(id?.toString());

  if (!isValidEntity(casino)) {
    return notFoundResult();
  }

  const casinoEntity = unwrapEntity(casino)!;

  const [rtpReviews, complaintsData] = await Promise.all([
    ssrApi.casinos.slotReviews(casinoEntity._id),
    api.complaints.getComplaintsByCasinoId(casinoEntity._id),
  ]);

  return {
    props: {
      casino: casinoEntity,
      rtpReviews: rtpReviews?.results ?? [],
      complaints: complaintsData?.results ?? [],
    },
  };
}
